import React from "react";
import {ArenaBaseModel} from "../arena-base.model";
import {ArenaGamesGridConfiguration, SwiperGamesListConfiguration} from "../../../../configurations/config-data-sections/arenas.configuration";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {IGamesListModel} from "../../lists/games-list-model.interface";
import {ListsSortOrderStorage} from "../../lists-sort-order-storage";
import {HomePageComponent} from "../../../../../components/home-page/home-page.component";
import {HOME_PAGE_ARENA, NEW_GAMES_ARENA_NAME} from "../../../arena-consts";
import {GAME_ORIENTATION_IDS} from "../../../../user-game-orientation/user-game-orientation.service.interface";
import { reaction } from "mobx";
import {GameInfo} from "../../../../games/game-info";

export class HomePageArenaModel extends ArenaBaseModel {
    constructor(services: IServiceFactoryExtended, postLoginListsSortOrderStorage: ListsSortOrderStorage) {
        super(HOME_PAGE_ARENA, services, postLoginListsSortOrderStorage);

        reaction(
            () => this.services.routing.currentRoute,
            (currentRoute) => {
                if (currentRoute.routeDefinition.data?.arenaType === NEW_GAMES_ARENA_NAME) {
                    this.services.homepage.resetNewAddedGames();
                }
            }, {
                fireImmediately: true
            }
        );
    }

    get maxSwipersToShow(): number {
        return 15;
    }

    get maxGamesToShowInList(): number {
        return 18
    }

    get aiEngine(): string {
        return "";
    }

    renderArena(): React.ReactElement | null {
        return (<HomePageComponent/>);
    }

    protected _getSwiperIdToPutOnTop(): number | null {
        //REQUIREMENT 1886942 -  exclude live casino orientation players
        const  gameGroupOrientation = this.services.userGameOrientation.gameGroup;
        if (gameGroupOrientation?.groupId && gameGroupOrientation?.groupId === GAME_ORIENTATION_IDS.LIVE_CASINO ) {
           return
        }


        return this.services.abTestingFeatureDataProvider.listOnTop;
    }

    protected _sortSwipersByAI(swipers: IGamesListModel[]): IGamesListModel[] {
        if(this._isUsingExternalAIForSwipersSorting) {
            return swipers;
        }

        return super._sortSwipersByAI(swipers);
    }

    protected _getSwipersConfigurations(): SwiperGamesListConfiguration[] {
        return this.services.configuration.data.homePage.gamesLists || [];
    }
    protected _getGridsConfigurations(): ArenaGamesGridConfiguration[] {
        return []
    }

    protected _getPromotionalBannerConfig() {
        const bannerConfig = this.services.configuration.data.homePage.promotionalBanner;
        if(!bannerConfig || this.services.miniOrbit.isEnabled) {
            return null;
        }

        return {
            position: bannerConfig.displayPlace + 1,
            templateID: bannerConfig.templateID,
            componentID: bannerConfig.componentID,
            fallbackComponent: bannerConfig.fallbackComponent,
            bannerAdminPlaceholderId: bannerConfig.bannerAdminPlaceholderId
        };
    }

    filterGamesByArenaType(gamesInfo: GameInfo[]): GameInfo[] {
        return gamesInfo;
    }
}